import React from 'react'

import { noop } from 'constants/global'
import { NurserySettingsFormBuilder } from 'services/nurseries/models'

import { generateRoute } from 'utils/routing'

import { Page, Section, Space, Spinner } from 'components'
import FormPreview from 'module/RegistrationForm/RegistrationForm/components/FormPreview'

import i18n from 'translations'

import { StyledWrapper } from './FormBuilderPreviewStyled'

interface FormBuilderPreviewViewProps {
  isFinanceV3Enabled: boolean
  isLoading: boolean
  nurseryFormBuilderSettings: NurserySettingsFormBuilder
}

const FormBuilderPreviewView: React.FC<FormBuilderPreviewViewProps> = ({
  isFinanceV3Enabled,
  isLoading,
  nurseryFormBuilderSettings,
}) => {
  const renderContent = () => {
    if (isLoading) {
      return <Spinner />
    }

    return (
      <StyledWrapper>
        <Space space="40px" />
        <FormPreview
          isFinanceV3Enabled={isFinanceV3Enabled}
          nurseryFormBuilderSettings={nurseryFormBuilderSettings}
          isPreview
          onSubmit={noop}
        />
      </StyledWrapper>
    )
  }

  return (
    <Page.Section
      actions={(
        <Section.Actions
          tertiary={{
            icon: 'chevron-left',
            label: i18n.t('module:Management:FormBuilder:backToFormBuilder'),
            to: generateRoute('MANAGEMENT.FORM_BUILDER'),
          }}
        />
      )}
      title={i18n.t('module:Management:FormBuilder:preview')}
      noBorder
    >
      {renderContent()}
    </Page.Section>
  )
}

export default FormBuilderPreviewView

